import { Fragment } from 'react'
import styled, { css } from 'styled-components'
import { getLimitNumText } from 'components/ActivityListCardItem/module/getLimitNumText'

interface ManagerReplyBadgeProps {
  managerRepliesCount: number
}

const ManagerReplyBadge = ({ managerRepliesCount }: ManagerReplyBadgeProps) => {
  return (
    <StyledWrapper>
      {managerRepliesCount ? (
        <Fragment>
          <span>담당자 답변 </span>
          <span className="reply-count">
            {getLimitNumText({
              number: managerRepliesCount,
              limit: 99,
            })}
          </span>
        </Fragment>
      ) : (
        '담당자 답변받기'
      )}
    </StyledWrapper>
  )
}

export default ManagerReplyBadge

const StyledWrapper = styled.div`
  ${({ theme }) => css`
    height: 24px;
    display: flex;
    border-radius: 3px;
    padding: 5px;
    background-color: rgba(0, 0, 0, 0.9);
    font-size: 10px;
    color: ${theme.background.bg_8};
    font-weight: bold;

    .reply-count {
      color: #ffd800;
    }
  `}
`
